import { TranslateFunction } from 'deckard-ui/dist/utils/translator';
import {
  centBasedCurrencyColumnByField,
  paymentStatusColumnByField,
} from './column-by-field';
import { columnGroupAttributesCreator } from './column-group-attributes';
import { PathTypedColDef, PathTypedColDefGroup } from './types';

type Args = {
  translate: TranslateFunction;
  /** IANA timezone */
  timezone: string;
};

export function createDefaultTOTColumns(
  args: Args
): (PathTypedColDef | PathTypedColDefGroup)[] {
  const { translate } = args;

  const columnGroupAttributes = columnGroupAttributesCreator(args.translate);

  return [
    {
      headerName: 'License Number',
      field: 'licenseNumber',
    },

    // Property Detail Column Group
    {
      ...columnGroupAttributes('Property Details'),
      children: [
        {
          headerName: 'Address',
          field: 'property.address',
          sortable: true,
        },
        {
          headerName: translate('APN', 'default', true),
          field: 'property.apn',
          sortable: true,
        },
      ],
    },
    // Reporter Details Column Group
    {
      ...columnGroupAttributes('Reporter Details'),
      children: [
        {
          headerName: 'Role',
          field: 'permitHolderDetails.title',
        },
        {
          headerName: 'Full Name',
          field: 'permitHolderDetails.name',
        },
        {
          headerName: 'Phone Number',
          field: 'permitHolderDetails.phone',
        },
        {
          headerName: 'Email Address',
          field: 'permitHolderDetails.email',
        },
      ],
    },
    // Tax Payments Column Group
    {
      ...columnGroupAttributes('Tax Payments'),
      children: [
        paymentStatusColumnByField({
          headerName: 'Status',
          field: 'taxPayments.status',
        }),
        {
          headerName: 'Reporting Date',
          field: 'taxPayments.paymentSubmissionDate',
          cellRenderer: 'dateCell',
          cellRendererParams: { _timezone: args.timezone },
          sortable: true,
        },
        centBasedCurrencyColumnByField({
          headerName: 'Taxes Paid',
          field: 'taxPayments.paidInCents',
        }),
        {
          headerName: 'Tax Estimated',
          field: 'taxEstimation.estimatedTaxInCents',
          sortable: false,
          cellRenderer: 'estimatedTaxCell',
        },
        {
          headerName: 'Payment Reference Number',
          field: 'taxPayments.paymentReferenceNumber',
        },
      ],
    },
    // Estimated bookings
    {
      ...columnGroupAttributes('Estimated Bookings'),
      children: [
        {
          headerName: 'Est. Nights Booked',
          field: 'taxEstimation.estimatedNightsBooked',
        },
        {
          headerName: 'Est. Nights Available',
          field: 'taxEstimation.estimatedNightsAvailable',
        },
      ],
    },
    // Reported Bookings Column Group
    {
      ...columnGroupAttributes('Reported Bookings'),
      children: [
        {
          headerName: 'No. Nights Booked',
          field: 'reportedBookings.nightsBooked',
        },
        {
          headerName: 'No. Nights Available',
          field: 'reportedBookings.nightsAvailable',
        },
      ],
    },
    // Owner Column Group
    {
      ...columnGroupAttributes('Owner'),
      children: [
        {
          headerName: 'Full Name',
          field: 'ownerDetails.name',
        },
        {
          headerName: 'Phone Number',
          field: 'ownerDetails.phone',
        },
        {
          headerName: 'Email Address',
          field: 'ownerDetails.email',
        },
      ],
    },
  ];
}
